export const PROJECT_CONSTANTS = {
    ACTIVE_PROJECT: 'cc_active_project'
};
